import React from 'react'

function DoubleStartIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="46.763" height="43.635" viewBox="0 0 46.763 43.635" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H43.972V36.374H0z"
            data-name="Rectangle 8059"
          ></path>
        </clipPath>
      </defs>
      <g data-name="Group 56108" transform="translate(-1763.145 -286.398)">
        <path
          fill="#fff"
          stroke="#263238"
          strokeWidth="1.4"
          d="M1779.725 291.202l6.275 8.794 10.562-.694-6.173 8.79 3.969 10.101-10.09-3.36-8.105 6.935-.063-10.868-8.986-5.812 10.05-3.357z"
          data-name="Path 67989"
        ></path>
        <path
          fill="#d3dade"
          stroke="#263238"
          strokeWidth="1.4"
          d="M1797.348 305.211l1.362 7.665 7.187 2.932-6.848 3.682-.571 7.768-5.596-5.39-7.542 1.868 3.392-7.012-4.087-6.614 7.69 1.057z"
          data-name="Polygon 18"
        ></path>
        <g clipPath="url(#clip-path)" data-name="Mask Group 245" transform="translate(1765 291)">
          <g data-name="Group 53723" transform="translate(10.041 15.619)">
            <g fill="none" stroke="#263238" strokeWidth="1.4" data-name="Group 55286">
              <path d="M3.782 5.494V2.823L1.98 1.543" data-name="Path 66548"></path>
              <path d="M21.646 12.39l.15-1.34 1.124-.56.608-.309" data-name="Path 66550"></path>
              <path d="M1.334 1.1h0L.17.252h0" data-name="Path 66555"></path>
              <path d="M21.431 14.585l.144-1.38" data-name="Path 66556"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default DoubleStartIcon
